import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import * as utils from './../../../../../../utilities/calendarUtilities';
import FilterWrapper from './../FilterWrapper';

import { getShortDateWithoutTimeStr } from './../../../../../../utilities/helpers'
import { useLanguage } from './../../../../../../context/LanguageContext';

const DateRangeFilter = props => {
  const { labels } = useLanguage();
  const FILTER_BAR = labels.FILTER_BAR || {};
  const getRosterPeriodMonth = () => {
    if (props.startDate) {
      const rosterDate = new Date(props.startDate);
      const year = rosterDate.getFullYear();
      const month = (rosterDate.getMonth() + 1).toString().padStart(2, '0');
      return `${year}-${month}-01`;
    }
    return null;
  };

  const rosterMonth = getRosterPeriodMonth();

  const startRef = useRef(null);
  const endRef = useRef(null);

  const handleStartFocus = () => {
    // show roster month visually when focusing if no real value selected
    if (!state.startInclusive && startRef.current) {
      startRef.current.value = rosterMonth || '';
    }
  };

  const handleStartBlur = () => {
    // clear visual value if user didn't select a date
    if (!state.startInclusive && startRef.current) {
      startRef.current.value = '';
    }
  };

  const handleEndFocus = () => {
    if (!state.endInclusive && endRef.current) {
      endRef.current.value = rosterMonth || '';
    }
  };

  const handleEndBlur = () => {
    if (!state.endInclusive && endRef.current) {
      endRef.current.value = '';
    }
  };

  const [state, setState] = useState({
    dropOpen: false,
    selectedItems: [],
    startInclusive: props.startInclusive,
    endInclusive: props.endInclusive,
    startInclusiveLabel: props.startInclusive ? getShortDateWithoutTimeStr(props.startInclusive) : (rosterMonth || 'yyyy-mm-dd'),
    endInclusiveLabel: props.endInclusive ? getShortDateWithoutTimeStr(props.endInclusive) : (rosterMonth || 'yyyy-mm-dd')
  });

  useEffect(() => {
    let initialDates = [props.startInclusive, props.endInclusive];
    initialDates = initialDates.filter(item => item);

    setState(state => (
      {
        ...state,
        startInclusive: props.startInclusive,
        endInclusive: props.endInclusive,
        selectedItems: initialDates
      }));

    if (!state.dropOpen && !props.startInclusive && !props.endInclusive) setState(state => ({ ...state, startInclusiveLabel: 'yyyy-mm-dd', endInclusiveLabel: 'yyyy-mm-dd' }))
    else {
      if (typeof props.startInclusive === 'number') {
        setState(state => ({ ...state, startInclusiveLabel: getShortDateWithoutTimeStr(props.startInclusive) }))
      }
      if (typeof props.endInclusive === 'number') {
        setState(state => ({ ...state, endInclusiveLabel: getShortDateWithoutTimeStr(props.endInclusive) }))
      }
    }
  }, [props.startInclusive, props.endInclusive, state.dropOpen])

  const onDateChange = (event, id) => {
    event.persist();
    setState(state => ({ ...state, [id]: event.target.value }));

    if (id === 'startInclusive') setState(state => ({ ...state, startInclusiveLabel: event.target.value }));
    else setState(state => ({ ...state, endInclusiveLabel: event.target.value }));

    setSelectedItems([state.startInclusive, state.endInclusive]);
  }

  const onCloseFilter = () => {
    let { startInclusive, endInclusive } = state;
    startInclusive = startInclusive && utils.getUTC(startInclusive).getTime();
    endInclusive = endInclusive && utils.getUTC(endInclusive).getTime();

    props.updateLocalFilterPayload({
      [props.filterKey]: {
        startInclusive: startInclusive || null,
        endInclusive: endInclusive || null
      }
    });
  }

  const setSelectedItems = (items) => {
    items = items.filter(item => item);
    setState(state => ({ ...state, selectedItems: items }));
  }

  const filterWrapperProps = {
    changesInFilter: state.selectedItems.length,
    id: props.id,
    isUserAdded: props.isUserAdded,
    name: props.name,
    onCloseFilter: onCloseFilter,
    removeFilter: props.removeFilter,
  };

  return (
    <FilterWrapper
      {...filterWrapperProps}
    >
      <div style={{ display: 'flex' }}>
        <TextField
          type="date"
          id="startInclusive"
          className="search-field-date"
          label={FILTER_BAR.DATE.FROM}
          onChange={(e) => onDateChange(e, 'startInclusive')}
          key={`start-${state.startInclusive || 'roster'}`}
          inputRef={startRef}
          onFocus={handleStartFocus}
          onBlur={handleStartBlur}
          defaultValue={state.startInclusive ? state.startInclusiveLabel : ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{
            placeholder: 'yyyy-mm-dd',
          }}
          variant="standard"
        />

        <TextField
          type="date"
          id="endInclusive"
          className="search-field-date"
          label={FILTER_BAR.DATE.TO}
          onChange={(e) => onDateChange(e, 'endInclusive')}
          key={`end-${state.endInclusive || 'roster'}`}
          inputRef={endRef}
          onFocus={handleEndFocus}
          onBlur={handleEndBlur}
          defaultValue={state.endInclusive ? state.endInclusiveLabel : ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{
            placeholder: 'yyyy-mm-dd',
          }}
          variant="standard"
        />

      </div>
    </FilterWrapper>
  );
}

DateRangeFilter.propTypes = {
  startInclusive: PropTypes.any,
  endInclusive: PropTypes.any,
  filterKey: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  isUserAdded: PropTypes.bool,
  name: PropTypes.string.isRequired,
  removeFilter: PropTypes.func,
  updateLocalFilterPayload: PropTypes.func.isRequired,
  startDate: PropTypes.object.isRequired,
  endDate: PropTypes.object.isRequired,
};

DateRangeFilter.defaultProps = {
  isUserAdded: false,
  items: [],
  removeFilter: () => { },
  startInclusive: null,
  endInclusive: null
};

export default DateRangeFilter;
